import { DoneRounded, Work } from '@mui/icons-material';
import { Box, IconButton, Paper, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function VideoWidget(props) {

    const {i18n} = useTranslation()

    const {videoWatched, video} = props;

    const translatedVideoTitle = video.title[i18n.language]

    if (!videoWatched) {
        return(
            <Paper key={video.id} sx={{p: 1, m: 1, display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <Typography>{translatedVideoTitle}</Typography>
                {
                    <Box>
                        <Tooltip enterTouchDelay={0} title="Nicht angeschaut">
                            <IconButton>
                                <Work color="secondary"/>
                            </IconButton>
                        </Tooltip>
                    </Box>
                }
            </Paper>
        )
    } else {
        return(
            <Paper key={video.id} sx={{p: 1, m: 1, display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <Typography>{translatedVideoTitle}</Typography>
                {
                    <Box>
                        {
                            videoWatched
                            ?
                            <Tooltip enterTouchDelay={0} title="Angeschaut">
                                <IconButton>
                                    <DoneRounded color="primary"/>
                                </IconButton>
                            </Tooltip>
                            :
                            <Tooltip enterTouchDelay={0} title="Nicht angeschaut">
                                <IconButton>
                                    <Work color="secondary"/>
                                </IconButton>
                            </Tooltip>
                        }
                    </Box>
                }
            </Paper>
        )
    }
}